<template>
  <div class="cangchu_sy">
    <div>
      <div class="headerSearch">
        <div class="sousuo">
          <el-form
            ref="search"
            style="display: flex"
            :model="searchForm"
            label-position="center"
            label-width="90px"
          >
            <el-form-item label="化学品:">
              <el-input
                v-model="searchForm.hxpMc"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item label="仓库名称:">
              <el-select v-model="searchForm.ckId" filterable placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="报备日期:">
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.beginTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
              <el-col
                style="text-align: center"
                class="line"
                :span="3"
              >-</el-col>
              <el-col :span="10">
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 100%"
                  placeholder="选择日期"
                />
              </el-col>
            </el-form-item>
            <el-form-item label="状态:" label-width="50px">
              <el-select v-model="searchForm.zt" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-button
              class="sousuoButton"
              icon="el-icon-search"
              round
              size="small"
              type="primary"
              @click="handleCurrentChange(1)"
            >搜索</el-button>
            <el-button
              class="resetbutton"
              icon="el-icon-refresh-right"
              @click="reset"
            >重置</el-button>
          </el-form>
        </div>
      </div>
      <div
        style="
          margin: auto;
          width: 95%;
          max-width: 1518px;
          background-color: white;
          padding-top: 40px;
          padding-bottom: 51px;
        "
      >
        <div class="tablemes">
          <el-table
            ref="cktable"
            v-loading="loading"
            :data="tableData"
            border
            :cell-style="cellStyle"
            :show-overflow-tooltip="true"
            :header-cell-style="{ background: '#F2F2F2' }"
            style="width: 100%"
          >
            <el-table-column>
              <template slot="header">
                <el-button
                  v-preventReClick
                  type="primary"
                  class="addButton"
                  size="mini"
                  style="border: none"
                  icon="el-icon-plus"
                  @click="addPupShow"
                >新增</el-button>

                <el-button
                  v-preventReClick
                  icon="el-icon-upload2"
                  size="mini"
                  @click="dcexcel"
                >导出</el-button>
              </template>
              <!-- <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column> -->

              <el-table-column
                v-for="(item, i) in table"
                :key="i"
                :show-overflow-tooltip="true"
                align="center"
                :label="item.label"
                :prop="item.key == 'bbrq' ? 'bbrq' : ''"
              >
                <template slot-scope="scope">
                  <span
                    v-if="item.label == '变更次数'"
                    style="cursor: pointer"
                    :title="scope.row[item.key]"
                    @click="bgcsClick(scope.row)"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                  <span
                    v-if="item.label !== '变更次数'"
                    :title="scope.row[item.key]"
                  >
                    {{ scope.row[item.key] }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-document"
                    size="mini"
                    @click="query(scope.$index, scope.row)"
                  >查看</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    v-preventReClick
                    type="primary"
                    icon="el-icon-edit"
                    size="mini"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-button>
                  <el-button
                    v-if="scope.row.zt == '00'"
                    type="primary"
                    class="deleteButton"
                    icon="el-icon-delete"
                    size="mini"
                    @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button>
                  <el-button
                    v-if="scope.row.zt != '00'"
                    v-preventReClick
                    :type="scope.row.zt == '11' ? 'info' : 'warning'"
                    :disabled="scope.row.zt == '11'"
                    icon="el-icon-edit"
                    size="mini"
                    @click="handleChange(scope.$index, scope.row)"
                  >变更</el-button>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <el-pagination
            background
            layout="prev,pager,next,jumper,total,sizes"
            :total="total"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
    <bgcs
      :bgwindow="bgwindow"
      :bgcs-t-k-name="bgcsTKName"
      @closeBindWarnStandard="handleCloseBindWarnStandard"
    />
    <cangchu-sy-pup
      ref="cangchuSy"
      :ccsytype="ccsytype"
      :djsjshow="djsjshow"
      :leixing="leixing"
      :bgdisable="bgdisable"
      :change-type="changeType"
    />
  </div>
</template>
<script>
import CangchuSyPup from './cangchuSyPup.vue'

import {
  getccsyMes,
  exportccsyList,
  getListCkcx,
  ckStatusList,
  deleteccsyMes,
  userInfofLogin
} from '@/assets/js/common.js'
import bgcs from '@/components/bgcs'
export default {
  components: { CangchuSyPup, bgcs },
  props: {},
  data() {
    return {
      bgcsTKName: '仓储损溢',
      bgwindow: false, // 变更次数弹窗
      // 登记时间
      djsjshow: false,
      // 变更
      bgdisable: false,
      loading: true,
      pupopShow: false,
      searchForm: {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      },
      table: [
        {
          key: 'wtDwMc',
          label: '委托单位'
        },
        {
          key: 'ckMc',
          label: '仓库名称'
        },
        {
          key: 'hxpMc',
          label: '化学品名称'
        },

        {
          key: 'bblxStr',
          label: '损溢类型'
        },
        {
          key: 'syslStr',
          label: '损溢数量'
        },
        {
          key: 'syyy',
          label: '损溢原因'
        },
        {
          key: 'bbrq',
          label: '报备日期',
          prop: 'bbrq'
        },
        {
          key: 'bgcs',
          label: '变更次数'
        },
        {
          key: 'ztStr',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      options1: [],
      options2: [],
      ccsytype: true,
      leixing: '',
      djsj: '',
      djr: '',
      changeType: false
    }
  },
  computed: {},
  watch: {},
  created() {
    this.search()
    getListCkcx().then((e) => {
      this.options2 = e.data.data
    })
    ckStatusList().then((e) => {
      this.options1 = e.data.data
    })
    userInfofLogin().then((e) => {
      this.djr = e.data.data.name
    })
  },
  mounted() {},

  beforeDestroy() {},
  methods: {
    // 点击变更次数
    bgcsClick(curRow) {
      this.curRowObj = curRow
      this.$bus.emit('bgcsOpen', curRow, '13')
      this.bgwindow =
        curRow.bgcs > 0 ? (this.bgwindow = !this.bgwindow) : false
    },
    // 关闭窗口
    handleCloseBindWarnStandard() {
      this.bgwindow = false
    },
    getccsyMess(dataObj) {
      getccsyMes(dataObj)
        .then((e) => {
          this.tableData = e.data.data.rows
          this.loading = false
          this.total = e.data.data.total
        })
        .catch(() => {
          this.loading = false
        })
    },
    getCurrentTime() {
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      mm < 10 ? '0' + mm : mm
      const dd =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate()
      const hh = new Date().getHours()
      const mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      const ss =
        new Date().getSeconds() < 10
          ? '0' + new Date().getSeconds()
          : new Date().getSeconds()
      this.djsj = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
    },
    // 添加
    addPupShow() {
      this.getCurrentTime()
      this.$refs.cangchuSy.dialogVisible = true
      this.$refs.cangchuSy.biangengShow = false
      this.$refs.cangchuSy.getformMes({ djsj: this.djsj, djr: this.djr })
      this.ccsytype = false
      this.changeType = false
      this.leixing = 'add'
      this.djsjshow = false
      this.bgdisable = false
      setTimeout(() => {
        this.$refs.cangchuSy.initCon({}, 13)
      }, 30)
    },
    // 查看
    query(index, row) {
      this.$refs.cangchuSy.dialogVisible = true
      this.$refs.cangchuSy.biangengShow = false
      this.$refs.cangchuSy.getformMes(row)
      this.ccsytype = true
      this.changeType = true
      this.leixing = 'ck'
      this.djsjshow = true
      this.bgdisable = false

      setTimeout(() => {
        this.$refs.cangchuSy.initCon(row, 13)
      }, 30)
    },
    // 编辑
    edit(index, row) {
      this.$refs.cangchuSy.dialogVisible = true
      this.$refs.cangchuSy.biangengShow = false
      this.$refs.cangchuSy.getformMes(row, 'edit')
      this.ccsytype = false
      this.changeType = false
      this.leixing = 'edit'
      this.djsjshow = true
      this.bgdisable = false

      setTimeout(() => {
        this.$refs.cangchuSy.initCon({}, 13)
      }, 30)
    },
    // 变更
    handleChange(index, row) {
      this.$refs.cangchuSy.dialogVisible = true
      this.$refs.cangchuSy.biangengShow = true
      this.$refs.cangchuSy.getformMes(row, 'change')
      this.ccsytype = false
      this.changeType = true
      this.leixing = 'change'
      this.djsjshow = true
      this.bgdisable = true

      setTimeout(() => {
        this.$refs.cangchuSy.initCon(row, 13)
      }, 30)
    },
    reset() {
      this.pagesize = 10
      this.currentPage = 1
      this.searchForm = {
        hxpMc: '',
        zt: '',
        ckId: '',
        beginTime: '',
        endTime: ''
      }
      this.search()
    },
    search() {
      this.getccsyMess({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpMc,
          zt: this.searchForm.zt,
          ckId: this.searchForm.ckId,
          beginTime: this.searchForm.beginTime,
          endTime: this.searchForm.endTime
        }
      })
    },
    // 点击导出按钮
    dcexcel() {
      exportccsyList({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          hxpMc: this.searchForm.hxpMc,
          zt: this.searchForm.zt,
          ckId: this.searchForm.ckId,
          beginTime: this.searchForm.beginTime,
          endTime: this.searchForm.endTime
        }
      }).then((e) => {
        const table = '仓储损益'
        const a = document.createElement('a')
        const blob = new Blob([e.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
        })
        const objectUrl = URL.createObjectURL(blob)
        a.setAttribute('href', objectUrl)
        a.setAttribute('download', table + '.xlsx')
        a.click()
      })
    },
    // 删除行数据
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteccsyMes(row.id).then((e) => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      let cellStyle
      if (columnIndex == 7) {
        switch (row.zt) {
          case '01':
            cellStyle = 'color:#6FC89A;font-weight:bold '
            break
          case '11':
            cellStyle = 'color:#43A5E2;font-weight:bold '
            break
          case '00':
            cellStyle = 'color:#000;font-weight:bold '
            break
          default:
            cellStyle = ''
            break
        }
        return cellStyle
      }
    }, // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    }
  }
}
</script>
<style scoped lang="less">
.el-table--border {
  z-index: 0;
}
.resetbutton {
  width: 90px;
  height: 39px;
  border-radius: 20px;
}
.cangchu_sy {
  // height: 100%;
  // width: 90%;
  // background-color: white;
  // margin: auto;
  .headerSearch {
    max-width: 1518px;
    width: 95%;
    margin: auto;
    margin-bottom: 11px;
    margin-top: 30px;
    background-color: white;
    padding: 30px 0 20px 0;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      margin-bottom: 10px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-color: #4170ff;
    }
    .chongzhiButton {
      width: 90px;
      height: 39px;
    }
  }
  .tablemes {
    margin: auto;
    width: 90%;
    max-width: 1375px;
    margin-bottom: 57px;
    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    // .addButton {
    //   color: #fff;
    //   background: #4170ff;
    //   border-radius: 3px;
    //   border-color: #4170ff;
    // }
    .deleteButton {
      background: #ff5721 !important;
      border-color: #ff5721 !important;
    }
    .el-button--warning {
      color: #fff;
      background: #feb800;
      border-radius: 3px;
      border-color: #feb800;
    }
    .el-button--primary {
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
</style>
